import { DateFormats, formatDate } from 'src/utils/time';

const convertDate = (date?: Date | null) =>
  date ? formatDate(date, DateFormats.YYYY_MM_DD) : undefined;

// Chronology of case dates: submittedAt -> readAt -> investigatingAt -> closedAt
export const calculateCaseDates = (dates: {
  submittedAt: Date | null;
  companyCreatedAt?: Date | null;
  readAt: Date | null;
  investigatingAt: Date | null;
  closedAt: Date | null;
}) => {
  const { submittedAt, companyCreatedAt, readAt, investigatingAt, closedAt } =
    dates;

  // Format dates for date picker
  const tempSubmittedAt = convertDate(submittedAt);
  const tempCompanyCreatedAt = convertDate(companyCreatedAt);
  const tempReadAt = convertDate(readAt);
  const tempInvestigatingAt = convertDate(investigatingAt);
  const tempClosedAt = convertDate(closedAt);

  // Calculate min and max of each date
  const todayDate = formatDate(
    new Date().toISOString(),
    DateFormats.YYYY_MM_DD,
  );

  const companyCreatedAtMin = tempSubmittedAt;
  const readAtMin = tempCompanyCreatedAt ?? tempSubmittedAt;
  const investigatingAtMin = tempReadAt ?? readAtMin;

  const closedAtMax = todayDate;
  const investigatingAtMax = tempClosedAt ?? todayDate;
  const readAtMax = tempInvestigatingAt ?? investigatingAtMax;
  const companyCreatedAtMax = tempReadAt ?? readAtMax;
  const submittedAtMax = tempCompanyCreatedAt ?? companyCreatedAtMax;

  const closedAtMin =
    tempInvestigatingAt ??
    tempReadAt ??
    tempCompanyCreatedAt ??
    tempSubmittedAt;

  const caseDates = {
    submittedAt: {
      value: tempSubmittedAt,
      min: undefined,
      max: submittedAtMax,
    },
    companyCreatedAt: {
      value: tempCompanyCreatedAt,
      min: companyCreatedAtMin,
      max: companyCreatedAtMax,
    },
    readAt: {
      value: tempReadAt,
      min: readAtMin,
      max: readAtMax,
    },
    investigatingAt: {
      value: tempInvestigatingAt,
      min: investigatingAtMin,
      max: investigatingAtMax,
    },
    closedAt: {
      value: tempClosedAt,
      min: closedAtMin,
      max: closedAtMax,
    },
  };

  return caseDates;
};
